import React from 'react';
import { Form, Label } from 'semantic-ui-react';

const MultiSelect = ({
  label,
  choices,
  selectValue,
  id,
  onMultiSelectChange
}) => (
  <Form>
    <Form.Field>{label}</Form.Field>
    {choices.map(({ value, label }) => (
      <Label
        color={selectValue.includes(value) ? 'teal' : undefined}
        onClick={() => onMultiSelectChange(id, value)}
        style={{ cursor: 'pointer', margin: '0.2em' }}
        key={value}
      >
        {label}
      </Label>
    ))}
  </Form>
);

export default MultiSelect;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/PreSection/MultiSelect.js